import { InputBase, TableRow } from "@material-ui/core";
import { createStyles, fade, withStyles } from "@material-ui/core/styles";

export const Input = withStyles((theme) =>
  createStyles({
    root: {
      borderRadius: theme.shape.borderRadius,
      "label + &": {
        marginTop: theme.spacing(3),
      },
      border: "1px solid #ced4da",
      "&:focus": {
        boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.1rem`,
        borderColor: theme.palette.primary.main,
        // zIndex: 1,
      },
      "&$error": {
        border: `1px solid ${theme.palette.error.main}`,
      },
    },
    input: {
      textAlign: "center",
      borderRadius: theme.shape.borderRadius,
      position: "relative",
      // backgroundColor: theme.palette.common.white,
      backgroundColor: "transparent",
      // border: "1px solid #ced4da",
      // padding: 16,
      fontSize: 14,
      //   width: "auto",
      padding: "10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [theme.typography.fontFamily].join(","),
      "&:focus": {
        boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.1rem`,
        borderColor: theme.palette.primary.main,
        // zIndex: 1,
      },
      "&[type=number]": {
        "-moz-appearance": "textfield",
        "-webkit-appearance": "textfield",
      },
      "&::-webkit-outer-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "&::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
    },
    error: {
      border: `1px solid ${theme.palette.error.main}`,
      // padding: "10px 12px",
    },
  })
)(InputBase);

export const InputLabel = withStyles((theme) =>
  createStyles({
    root: {
      "label + &": {
        // marginTop: theme.spacing(3),
      },
    },
    input: {
      textAlign: "center",
      // borderRadius: theme.shape.borderRadius,
      position: "relative",
      // backgroundColor: theme.palette.common.white,
      backgroundColor: "transparent",
      // border: "1px solid #ced4da",
      // padding: 16,
      fontSize: 14,
      //   width: "auto",
      padding: "0px 0px",
      // transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [theme.typography.fontFamily].join(","),
      // "&:focus": {
      //   boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.1rem`,
      //   borderColor: theme.palette.primary.main,
      // },
    },
    error: {
      borderColor: `${theme.palette.error.light}`,
    },
  })
)(InputBase);

export const StyledTableRow = withStyles(() => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "#f3f2f3",
    },
    "&:nth-of-type(odd)": {
      backgroundColor: "#fff",
    },
  },
}))(TableRow);
